import { lazy } from 'react';

const Rebates = lazy(() => import('./AdminRebatesPage'));

const AdminRebatesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'admin/rebates',
      element: <Rebates />,
    },
  ],
};

export default AdminRebatesConfig;
